function compareIds(id1, id2) {
  if (typeof id1 !== 'string' || typeof id2 !== 'string') {
    return false;
  }

  return id1.toUpperCase() === id2.toUpperCase();
}

export default {
  compareIds,
};
